import { useTellescopeQuery, TellescopeModelFromName } from "@tellescope/tanstack-query";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { TextCell } from "../TextCell";

export type EnduserRecord = TellescopeModelFromName<"endusers">;

export interface EnduserCellWrapperProps {
  enduserId?: string;
  children: (enduser: EnduserRecord) => ReactNode;
  fallback?: ReactNode;
}

/**
 * Wrapper component that fetches enduser data and passes it to children
 * Used for rendering read-only enduser fields in ticket tables
 */
export const EnduserCellWrapper = ({ enduserId, children, fallback }: EnduserCellWrapperProps) => {
  const { t } = useTranslation("tickets");

  const enduserQuery = useTellescopeQuery({
    model: "endusers",
    method: "getOne",
    request: enduserId ?? "",
    enabled: !!enduserId,
  });

  if (!enduserId) {
    return fallback ?? <TextCell className="text-muted-foreground">{t("No patient")}</TextCell>;
  }

  if (enduserQuery.isLoading) {
    return <TextCell className="text-muted-foreground">{t("Loading...")}</TextCell>;
  }

  if (enduserQuery.isError || !enduserQuery.data) {
    return <TextCell className="text-muted-foreground">{t("Unknown patient")}</TextCell>;
  }

  return <>{children(enduserQuery.data)}</>;
};
